import { FunctionComponent } from "react";
import { FieldProps } from "@animech/axiom-ui-builder";
import * as Styled from "./toggle-button-group.style";
import { Root } from "@definitions";

export type ExtendedFieldProps = {
	showLabel?: boolean;
};

export type ToggleButtonGroupProps = FieldProps<Root> & ExtendedFieldProps;

export const ToggleButtonGroup: FunctionComponent<ToggleButtonGroupProps> = ({
	fieldValues = [],
	value,
	onValueChange,
	fieldMeta,
	fieldValuesMeta,
	showLabel = false,
}) => {
	return (
		<Styled.Root>
			<Styled.Container>
				{showLabel && <Styled.Label>{fieldMeta?.label}</Styled.Label>}
				<Styled.Group>
					{fieldValues.map((fieldValue, index) => (
						<Styled.Item key={index}>
							<Styled.Toggle
								value={value === fieldValue}
								onValueChange={() =>
									onValueChange?.(value === fieldValue ? undefined : fieldValue)
								}
								label={fieldValuesMeta?.[index].label}
							/>
						</Styled.Item>
					))}
				</Styled.Group>
			</Styled.Container>
		</Styled.Root>
	);
};
